/** @jsx jsx */
import { jsx, css } from '@emotion/react'
import React from 'react'
import RoadInfo from './RoadInfo'
import { StepsPathRank } from './StepsPathList'
import StepsPosition from './StepsPosition'
import SvgTile from './SvgTile'

const transformOddCss = css`
  transform: rotateX(180deg);
  transform-origin: center;
`

const transformEvenCss = css`
  transform: rotate(180deg) translateX(30px);
  transform-origin: center;
`

const CORNER_OFFSET = 13
interface Props {
  index: number
  startPoint: number
  endPoint: number
  currentPoint: number
  rank: StepsPathRank
  measurement: 'km' | 'miles'
}
function RoadTile(props: Props) {
  const { index, startPoint, endPoint, currentPoint, rank, measurement } = props

  let isEven = index % 2 === 0

  let point = currentPoint - CORNER_OFFSET

  let filledPercent = 0
  if (point >= endPoint) filledPercent = 100
  else if (point <= startPoint) filledPercent = 0
  else {
    const tileSize = endPoint - startPoint
    const tileProgress = point - startPoint
    filledPercent = (tileProgress / tileSize) * 100
  }

  const isIndicatorVisible = (filledPercent > 0 || !index) && filledPercent < 100
  const isRankPassed = currentPoint >= endPoint

  return (
    <div
      css={
        index &&
        css`
          margin-top: -19px;
        `
      }
    >
      <div
        css={css`
          position: relative;
        `}
      >
        <div css={isEven ? transformEvenCss : transformOddCss}>
          <SvgTile filledPercent={filledPercent} isEven={isEven} />
        </div>

        {rank ? <RoadInfo rank={rank} isEven={isEven} isActive={isRankPassed} measurement={measurement} /> : null}
        {isIndicatorVisible && <StepsPosition pathPosition={filledPercent} isEven={isEven} />}

        {/* <div */}
        {/*  css={css` */}
        {/*    position: absolute; */}
        {/*    top: 0; */}
        {/*    left: 0; */}
        {/*    right: 0; */}
        {/*    bottom: 0; */}
        {/*  `} */}
        {/* > */}
        {/*  <div css={isEven ? transformEvenCss : transformOddCss}> */}
        {/*    <SvgTile fill={'#F9B22D'} filledPercent={filledPercent} /> */}
        {/*  </div> */}
        {/* </div> */}
        {/* <img src={roadTile} alt={'road'} /> */}
      </div>
    </div>
  )
}

export default RoadTile
